import { fetcher } from '@commenda/utils';

export async function lockIndirectTaxTransaction(
  transactionId: string,
  corporationId: number
): Promise<{ success: boolean; error?: string; data?: unknown }> {
  try {
    const response = await fetcher(
      `new-sales-tax/transactions/${transactionId}/lock`,
      { method: 'POST', body: { corporation_id: corporationId } },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return { success: false, error: errorData.message || 'Failed to lock transaction' };
    }

    return { success: true, data: await response.json() };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to lock transaction',
    };
  }
}
